var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { divider, color } from '../../../constants';
import { DIVIDER_SIZE } from '../utils';
export var DataGridRow = styled.div.attrs(function (_a) {
    var className = _a.className;
    return ({
        className: (className !== undefined ? className : '') + " DataGrid-Row"
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* If Edge/IE11, fallback to basic flex implementation */\n  @supports not (display: contents) {\n    display: flex;\n  }\n\n  @supports (display: contents) {\n    display: contents;\n  }\n\n  &:last-child > .DataGrid-Cell {\n    border-bottom: 0;\n  }\n  & > .DataGrid-Cell {\n    border-left: ", " solid ", ";\n    background-color: ", ";\n    ", "\n  }\n  & > .DataGrid-Cell:first-child {\n    border-left: 0;\n  }\n  &:hover > .DataGrid-Cell {\n    background-color: ", ";\n  }\n"], ["\n  /* If Edge/IE11, fallback to basic flex implementation */\n  @supports not (display: contents) {\n    display: flex;\n  }\n\n  @supports (display: contents) {\n    display: contents;\n  }\n\n  &:last-child > .DataGrid-Cell {\n    border-bottom: 0;\n  }\n  & > .DataGrid-Cell {\n    border-left: ", " solid ", ";\n    background-color: ",
    ";\n    ", "\n  }\n  & > .DataGrid-Cell:first-child {\n    border-left: 0;\n  }\n  &:hover > .DataGrid-Cell {\n    background-color: ",
    ";\n  }\n"])), DIVIDER_SIZE, divider.solid, function (_a) {
    var selected = _a.selected;
    return selected !== undefined && selected
        ? color.theme.state.currentActive.background
        : color.pureWhite;
}, function (_a) {
    var cursor = _a.cursor;
    return cursor !== undefined && "cursor: " + cursor + ";";
}, function (_a) {
    var selected = _a.selected;
    return selected !== undefined && selected
        ? color.theme.state.hover.background
        : color.theme.state.hover.background;
});
var templateObject_1;
//# sourceMappingURL=Row.styles.js.map